export const RECEIVE_POLES = 'RECEIVE_POLES';
export const GET_POLES = 'GET_POLES';
export const SET_POLE = 'SET_POLE';
export const UPDATE_POLE = 'UPDATE_POLE';
export const DELETE_POLE = 'DELETE_POLE';
export const FETCH_POLES = 'FETCH_POLES';
